module.exports = __webpack_public_path__ + "static/media/4.9a9aa344.jpg";